import { render, staticRenderFns } from "./PropertySubCategory.vue?vue&type=template&id=32797fdd"
import script from "./PropertySubCategory.vue?vue&type=script&lang=js"
export * from "./PropertySubCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports